import { ChevronDown } from "lucide-react";
import type { JSX, SelectHTMLAttributes } from "react";

import { cn } from "@/shared/lib/cn";

export function Select({
  className,
  children,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement>): JSX.Element {
  return (
    <div className="relative inline-flex">
      <select
        className={cn(
          "h-9 appearance-none rounded-[10px] border border-[var(--premium-border-strong)] bg-white pl-3 pr-9 text-sm text-[var(--text-primary)] shadow-[var(--sh-xs)] outline-none transition focus:border-[var(--brand-500)] focus-ring",
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden
        className="pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-[var(--text-subtle)]"
      />
    </div>
  );
}
